// extracted by mini-css-extract-plugin
export default {"form":"form__E1FBqZ5ZgpDYEJw0QYmA","title":"title__nRCZ6Ax1D0iJMsmCyvZr","subtitle":"subtitle__ngoQhekW71vvWE9gSYAU","cta":"cta__w1Tmwd8_WI7QrBedleg1"};